/*
  maiocchi-homepage.js  -  July 2026

  Moves the category tiles to sit directly BELOW the hero, rather than above it.

  WHY IT'S DONE IN JAVASCRIPT
  The hero is the first section inside {{ content_for_layout }}, which Liquid renders as one
  block - there is no hook to slot something in after it without rewriting templates/index.json
  (a 50KB auto-generated file that the theme editor also writes to, so hand-editing it is a good
  way to lose work).

  WHY THIS IS SAFE
  The tiles are rendered ABOVE the hero in theme.liquid, where they already work perfectly well.
  This script simply relocates them. If it fails, or JS is off, the shopper still gets a working
  category strip - just above the hero instead of below it. There is no broken state.

  WHY BELOW THE HERO
  71% of our visitors are brand new, most of them straight off a Meta ad, so the hero still has
  to do the brand work - lead a stranger with a grid of tiles and we are a catalogue, not a
  designer. But the Clarity heatmap shows 18% of all homepage taps are people opening the
  hamburger to find a category, so the categories need to be right there when the hero is done.

  Hero, then categories, then product. In that order.
*/
(function () {
  function relocate() {
    var tiles = document.querySelector('.mct');
    if (!tiles || tiles.dataset.moved) return;

    var main = document.getElementById('MainContent');
    if (!main) return;

    // The hero is the first rendered section on the homepage.
    var firstSection = main.querySelector('.shopify-section');
    if (!firstSection || !firstSection.parentNode) return;

    firstSection.parentNode.insertBefore(tiles, firstSection.nextSibling);
    tiles.dataset.moved = '1';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocate);
  } else {
    relocate();
  }
})();
